import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { MyApp } from './app.component';
import { TeaserComponentModule } from '../components/teaser/teaser.module';
import { RestWS } from './services/restService';
import { AbstractWS } from '../components/teaser/teaser.service';
import { StylizerProvider } from '../providers/StylizerProvider';

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
	declarations: [
		MyApp
	],
	imports: [
		BrowserModule,
		TeaserComponentModule,
		HttpModule,
		HttpClientModule,
		IonicModule.forRoot(
			MyApp,
			{
				mode: 'ios',
				preloadModules: true
			}
		),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: (createTranslateLoader),
				deps: [HttpClient]
			}
		})
	],
	bootstrap: [IonicApp],
	entryComponents: [
		MyApp
	],
	providers: [
		StatusBar,
		SplashScreen,
		{ provide: ErrorHandler, useClass: IonicErrorHandler },
		RestWS,
		AbstractWS,
		StylizerProvider
	]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts